const state = {
    alert: {
        alert: false,
        alertTitle: '',
        alertMessage: '',
        color: ''
    }
}

const getters = {
    getGlobalAlert: state => state.alert
}

const actions = {
    setGlobalAlert({ commit }, alert) {
        commit('setAlert', alert)
    }
}

const mutations = {
    setAlert: (state, alert) => (state.alert = alert)
}

export default {
    state,
    getters,
    actions,
    mutations
}